import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { useState } from 'react';
import { StickyBarContainer } from '../../../containers/StickyBarContainer';
import { ProductDetailComparePopup } from '../compare-popup/ProductDetailComparePopup';
export const ProductDetailOverlays = () => {
    const [isHiddenStickyBar, setHiddenStickyBar] = useState(true);
    const { feature_toggles: { show_sticky_bar_pdp }, pageInfo: { isGiftCardPage }, } = useAemConfig();
    return (_jsxs(_Fragment, { children: [show_sticky_bar_pdp && !isGiftCardPage && (_jsx(StickyBarContainer, { isHidden: isHiddenStickyBar, setHidden: setHiddenStickyBar })), _jsx(ProductDetailComparePopup, { isStickyBar: !isHiddenStickyBar })] }));
};
